import React, { useState } from 'react';
import { Mail, MapPin, ArrowUpRight, Check } from 'lucide-react';
import { Reveal } from '../components/Reveal';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', org: '', interest: 'Subscribe', message: '' });
  const [sent, setSent] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = (e) => {
    e.preventDefault();
    setSent(true);
    setForm({ name: '', email: '', org: '', interest: 'Subscribe', message: '' });
    setTimeout(() => setSent(false), 4000);
  };

  const interests = ['Subscribe', 'Club membership', 'Events & partnership', 'Editorial / press'];

  return (
    <div className="pt-32 md:pt-40 pb-24">
      <div className="section-pad">
        <div className="max-w-[1500px] mx-auto grid lg:grid-cols-2 gap-16">
          <Reveal>
            <div>
              <p className="eyebrow text-[#D01919] mb-4">Get in touch</p>
              <h1 className="font-display text-5xl md:text-7xl leading-[0.95]">Let’s talk energy.</h1>
              <p className="text-[#666666] text-lg mt-6 max-w-md">
                Whether you want the monthly edition, a seat at the table, or to partner on an event — we’d love to hear from you.
              </p>

              <div className="mt-12 space-y-6">
                <div className="flex items-start gap-4">
                  <span className="w-11 h-11 rounded-full bg-[#f4f4f4] flex items-center justify-center shrink-0">
                    <Mail size={18} className="text-[#111111]" />
                  </span>
                  <div>
                    <p className="font-medium">Email</p>
                    <p className="text-[#666666]">editor@enersider.com</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <span className="w-11 h-11 rounded-full bg-[#f4f4f4] flex items-center justify-center shrink-0">
                    <MapPin size={18} className="text-[#111111]" />
                  </span>
                  <div>
                    <p className="font-medium">Bureaus</p>
                    <p className="text-[#666666]">New Delhi · London · Abu Dhabi · New York</p>
                  </div>
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <form onSubmit={submit} className="bg-[#f4f4f4] rounded-3xl p-8 md:p-10">
              <div className="grid sm:grid-cols-2 gap-5">
                <div>
                  <label className="text-sm font-medium">Name</label>
                  <input value={form.name} onChange={update('name')} required className="mt-1.5 w-full bg-[#ffffff] rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-[#111111] transition" placeholder="Jane Doe" />
                </div>
                <div>
                  <label className="text-sm font-medium">Email</label>
                  <input type="email" value={form.email} onChange={update('email')} required className="mt-1.5 w-full bg-[#ffffff] rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-[#111111] transition" placeholder="jane@company.com" />
                </div>
              </div>
              <div className="mt-5">
                <label className="text-sm font-medium">Organisation</label>
                <input value={form.org} onChange={update('org')} className="mt-1.5 w-full bg-[#ffffff] rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-[#111111] transition" placeholder="Company / institution" />
              </div>
              <div className="mt-5">
                <label className="text-sm font-medium">I’m interested in</label>
                <div className="flex flex-wrap gap-2 mt-2">
                  {interests.map((it) => (
                    <button type="button" key={it} onClick={() => setForm({ ...form, interest: it })}
                      className={`px-3.5 py-2 rounded-full text-sm font-medium transition-colors ${form.interest === it ? 'bg-[#111111] text-[#ffffff]' : 'bg-[#ffffff] text-[#111111] hover:bg-[#e5e5e5]'}`}>
                      {it}
                    </button>
                  ))}
                </div>
              </div>
              <div className="mt-5">
                <label className="text-sm font-medium">Message</label>
                <textarea value={form.message} onChange={update('message')} rows={4} className="mt-1.5 w-full bg-[#ffffff] rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-[#111111] transition resize-none" placeholder="Tell us a little more…" />
              </div>
              <button type="submit" className="mt-6 w-full inline-flex items-center justify-center gap-2 bg-[#111111] text-[#ffffff] font-medium px-6 py-4 rounded-full hover:bg-[#D01919] transition-colors">
                {sent ? (<><Check size={18} /> Message sent</>) : (<>Send message <ArrowUpRight size={18} /></>)}
              </button>
              {sent && <p className="text-center text-sm text-[#111111] mt-3">Thanks — we’ll be in touch shortly.</p>}
            </form>
          </Reveal>
        </div>
      </div>
    </div>
  );
}
